import { provideHttpClient, withXhr } from '@angular/common/http';
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { TranslationService } from './translation.service';

/**
 * Registers HTTP loading and bootstrap initialization for the i18n layer.
 */
export function provideI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(withXhr()),
    provideAppInitializer(() => {
      const translation = inject(TranslationService);
      return translation.initialize();
    }),
  ]);
}
